import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface AssignedCustomerOperationsPageOptions extends PageOptionsBase {
    urlList: string;
    urlCustomerDetail: string;
    urlCustomerOperationDetail: string;
    urlRemoveSelected: string;
    bonusId: string;
    localizer: {
        StatusActive: string;
        StatusInactive: string;
        StatusInvalid: string;
        StatusRemoved: string;
    }
}

export class AssignedCustomerOperationsPage extends PageBase<AssignedCustomerOperationsPageOptions> {

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;
    private _btnRemoveSelected: JQuery;

    constructor(options: AssignedCustomerOperationsPageOptions) {
        super(options);
        
        var getCustomerDetailUrl = (rowData: any): string => (`${options.urlCustomerDetail}/${rowData.CustomerId}`);
        var getOperationDetailUrl = (rowData: any): string => (`${options.urlCustomerOperationDetail}/${rowData.CustomerOperationId}`);

        this._tableId = "tableAssignedCustomerOperations";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'CustomerOperationId',
            autoWidth: true,
            pageLength: 100,
            lengthMenu: [[20, 100, 200, -1], [20, 100, 200, "All"]],
            columns: [
                {
                    orderable: false,
                    searchable: false,
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        if (rowData.RelationStatus == 'Removed') {
                            return (``);
                        } else {
                            return (`<input id='chckbx${rowData.Id}' name='selectedCustomerOperations' value='${rowData.CustomerOperationId}' type='checkbox' />`);
                        }
                    }
                },
                {
                    data: 'CustomerName',
                    render: (data: any, type: any, rowData: any) => {
                        return (`<a href='${getCustomerDetailUrl(rowData)}'>${data}</a>`);
                    }
                },
                {
                    data: "CustomerCode",
                },
                {
                    data: "CustomerOperationName",
                    render: (data: any, type: any, rowData: any) => {
                        return (`<a href='${getOperationDetailUrl(rowData)}'>${data}</a>`);
                    }
                },
                {
                    data: "CustomerOperationCode",
                },
                {
                    data: "AssignedDate",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: "RemovedDate",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span>${DateUtils.toDefaultWithTime(data)}</span>`)
                },
                {
                    data: "RelationStatus"
                },
            ]
        };
    }

    private removeSelected(that: any): void {
        var ids = $("input[name='selectedCustomerOperations']:checked").map(function () {
            return $(this).val();
        });
        var idsToAdd = ids.get();
        if (!idsToAdd || idsToAdd.length === 0) {
            return;
        }
        $.ajax({
            url: this._options.urlRemoveSelected,
            type: "POST",
            data: { bonusId: this._options.bonusId, customerOperationIds: idsToAdd },
            success: function () {
                that._table.draw();
            }
        });
    }

    private openDialog() {
        document.getElementById("areYouSureConfirmation").hidden = false;
    }

    private closeDialog() {
        document.getElementById("areYouSureConfirmation").hidden = true;
    }

    init(): void {
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);
        this._btnRemoveSelected = Utils.getJQueryById("lnkRemoveSelected");
        var confirmButton = <HTMLButtonElement>document.getElementById("btnConfirm");
        var closeButton = <HTMLButtonElement>document.getElementById("btnHideConfirmation");
        var that = this;
        this._btnRemoveSelected.on("click", (e) =>
        {
            var ids = $("input[name='selectedCustomerOperations']:checked").map(function () {
                return $(this).val();
            });
            var idsToAdd = ids.get();
            if (!idsToAdd || idsToAdd.length === 0) {
                return;
            }
            this.openDialog();
        });
        confirmButton.onclick = () => {
            this.removeSelected(that);
            this.closeDialog();
        };
        closeButton.onclick = () => this.closeDialog();
    }
}



/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ProgressiveBonuses/AssignedCustomerOperationsPage.ts
 **/